import { visionLabApi } from '@/app/apiClient';
import { SUPERVISOR_PAGE_SIZE } from '@/features/supervisor/config/constants';
import type {
  SupervisorActivitySessionFilters,
  SupervisorCamerasFilters,
  SupervisorCamerasPage,
  SupervisorMember,
  SupervisorMemberOption,
  SupervisorPage,
  SupervisorSummary,
  SupervisorTeamScope,
} from '@/features/supervisor/types/supervisor';
import type { ApiCallOptions } from '@/shared/api/client';

export function fetchSupervisorSummary(scope: SupervisorTeamScope, options: ApiCallOptions) {
  return visionLabApi.get<SupervisorSummary>('/field-log-supervisor/summary', {
    ...options,
    searchParams: scope,
  });
}

export function fetchSupervisorMembers(
  scope: SupervisorTeamScope,
  cursor: string | undefined,
  options: ApiCallOptions,
) {
  return visionLabApi.get<SupervisorPage<SupervisorMember>>('/field-log-supervisor/members', {
    ...options,
    searchParams: { ...scope, cursor, limit: SUPERVISOR_PAGE_SIZE },
  });
}

export function fetchSupervisorMemberOptions(
  params: { organizationId?: readonly string[]; purpose: 'create' | 'filter'; q?: string },
  cursor: string | undefined,
  options: ApiCallOptions,
) {
  return visionLabApi.get<SupervisorPage<SupervisorMemberOption>>('/field-log-member-options', {
    ...options,
    searchParams: { ...params, cursor, limit: SUPERVISOR_PAGE_SIZE },
  });
}

export function fetchSupervisorCameras(
  filters: SupervisorCamerasFilters,
  cursor: string | undefined,
  options: ApiCallOptions,
) {
  return visionLabApi.get<SupervisorCamerasPage>('/field-log-supervisor/cameras', {
    ...options,
    searchParams: { ...filters, cursor, limit: SUPERVISOR_PAGE_SIZE },
  });
}

export function exportSupervisorSessions(filters: SupervisorActivitySessionFilters) {
  return visionLabApi.post<Blob>('/field-log-sessions/export', {
    json: { filters },
    responseType: 'blob',
  });
}
